import Compressor from "compressorjs";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { API_URL, END_POINTS } from "../constants/url";
import { getFromStorage } from "../helpers/storage";

interface UploadResponse {
  statusCode: number;
  code: number;
  data: any;
  message: string;
}
export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.6,

      success: async (compressedResult) => {
        const formData = new FormData();
        formData.append("file", compressedResult as any);

        const headers = {
          Accept: "application/json",
          "x-portal": "ADMIN",
        };

        try {
          const res = await fetch(API_URL + END_POINTS.upload, {
            method: "POST",
            headers,
            body: formData,
          });
          const response = await res.json();
          resolve(response);
        } catch (error) {
          reject(error);
        }
      },
    });
  });
};

export const UploadVideo = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append("image", imageObject as any);
    let headers = {
      Accept: "application/json",
    };

    try {
      const res = await fetch(API_URL + END_POINTS.upload, {
        method: "POST",
        headers,
        body: formData,
      });
      let response = await res.json();
      resolve(response); // Resolve the Promise with the response
    } catch (error) {
      console.log(error, ">>>>>>>>>");
      reject(error); // Reject the Promise with the error
    }
  });
};

export const Uploadpdf = async (imageObject: any) => {
  const formData = new FormData();

  formData.append("media", imageObject as any);

  const getToken = await getFromStorage(STORAGE_KEYS.token);
  const token = getToken ? JSON.parse(`${getToken}`) : null;
  let headers = {
    Accept: "application/json",
    Authorization: "Bearer " + token,
  };
  try {
    const res = await fetch(API_URL + END_POINTS.upload, {
      method: "POST",
      headers,
      body: formData,
    });
    let response = await res.json();
    return response;
  } catch (error) {
    console.log(error, ">>>>>>>>>");
    return error;
  }
};
